/**
 * Copy text to the clipboard (the "Copy JSON" action — a support person
 * lifts the raw model response into an external editor rather than
 * squinting at an inline `<pre>`).
 *
 * A thin platform wrapper, kept separate from the components so the
 * detail view can inject a spy in tests without touching the real
 * clipboard (mirrors `./download.ts`). Prefers the async Clipboard API;
 * falls back to a hidden-textarea `execCommand("copy")` for non-secure
 * contexts (plain-HTTP LAN dev) where `navigator.clipboard` is absent.
 */
export type CopyTextToClipboard = (text: string) => Promise<void>;

export const copyTextToClipboard: CopyTextToClipboard = async (text) => {
  if (
    typeof navigator !== "undefined" &&
    navigator.clipboard !== undefined &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    await navigator.clipboard.writeText(text);
    return;
  }

  // Fallback for non-secure contexts: a transient off-screen textarea.
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  try {
    textarea.select();
    document.execCommand("copy");
  } finally {
    textarea.remove();
  }
};
